import BaseControl from "components/propertyControls/BaseControl";
import Form from "ee/components/InputsForm/Form";
import React from "react";
import SectionField from "ee/components/InputsForm/Fields/SectionField";
import { generateDefaultInputSection } from "ee/components/InputsForm/Fields/helper";
import { klona } from "klona";
import type { ControlProps } from "components/propertyControls/BaseControl";
import type { Module } from "ee/constants/ModuleConstants";
import type { Diff } from "deep-diff";

class UIModuleInputsFormControl extends BaseControl<ControlProps> {
  onUpdateInputsForm = (
    values: { inputsForm: Module["inputsForm"] },
    changes?: Diff<{ inputsForm: Module["inputsForm"] }, unknown>[],
  ) => {
    const newValues = klona(values.inputsForm);

    newValues.forEach((section) => {
      section.children.forEach((sectionProperties) => {
        sectionProperties.propertyName = `inputs.${sectionProperties.label}`;
      });
    });

    this.updateProperty(this.props.propertyName, { newValues, changes });
  };

  getDefaultValue = () => {
    const { propertyValue } = this.props;
    const defaultInputSection = generateDefaultInputSection();

    if (propertyValue) {
      return {
        inputsForm: propertyValue,
      };
    }

    return { inputsForm: [defaultInputSection] };
  };

  render() {
    const { propertyValue } = this.props;
    const defaultValues = this.getDefaultValue();

    return (
      <Form
        dataTreePathPrefix="inputsForm"
        defaultValues={defaultValues}
        evaluatedValues={propertyValue}
        onUpdateForm={this.onUpdateInputsForm}
      >
        <SectionField name="inputsForm" />
      </Form>
    );
  }

  static getControlType() {
    return "UI_MODULE_INPUTS_FORM";
  }
}

export type UIModuleInputsFormControlProps = ControlProps;

export default UIModuleInputsFormControl;
